import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";
// import { Modal } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal'
import styles from './styles.css'
import { FormGroup, Input, Label } from 'reactstrap'
import { useForm } from 'react-hook-form'

function ModelsList() {
  const loaderCss = css`
    margin: auto;
  `;
  const id = useParams();
  const history = useHistory();
  const [models, setModels] = useState([]);
  const [trimEditName, setTrimEditName] = useState();
  const [trimEditModel, setTrimEditModel] = useState();
  const [trimEditId, setTrimEditId] = useState();
  const [trims, setTrims] = useState([]);
  const [lastTrimModelId, setLastTrimModelId] = useState([]);
  const [modalName, setModalName] = useState('');
  const [trimName, setTrimName] = useState('');
  const [modelChange, setModelChange] = useState('');
  const [loading, setloading] = useState([]);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState('');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);


  const {
    register,
    handleSubmit, reset,
    formState: { errors },
  } = useForm()


  useEffect(() => {
    getModels();
  }, []);

  const editModel = (id) => {
    history.push(`admin/maker/model/edit/${id}`);
  }
  const getModels = () => {
    axios.post(URL_API + `posts/vehicle/${id.id}`).then((response) => {
      if (response.data.status === 200) {
        setModels(response.data.models);
      }
    });
  };

  const onchangeAddTrimButton = () => {
    setShowStatus('Add')
    reset()
  }

  const editModelTrim = (id) => {
    setShow2(true)
    setShowStatus('Edit')
    axios.get(URL_API + `auth/admin/trim/${id}/edit`).then((response) => {
      if (response.data.status === 200) {
        setTrimEditName(response?.data?.trim?.trim_name)
        setTrimEditModel(response?.data?.trim?.vehicle_modle_id)
        setTrimEditId(response?.data?.trim?.id)
        // setModels(response.data.models);
      }
    });
  }




  const destroyModel = (id) => {
    axios
      .post(URL_API + `auth/admin/modle/destroy/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          toast.success("Model Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getModels();
        }
      });
  };


  const getTrimList = (modelId) => {
    setShow(true)
    setLastTrimModelId(modelId)

    axios
      .get(URL_API + `auth/admin/trim-list/${modelId}`)
      .then((response) => {
        if (response?.data?.status === 200) {
          setTrims(response?.data?.trims)
          setModalName(response?.data?.model)
          // toast.success("Model Deleted Successfully", {
          //   position: toast.POSITION.TOP_RIGHT,
          //   autoClose: 2000,
          // });
        }
      });
  }



  const onTrimsubmit = (e) => {
    const formData = new FormData()
    formData.append('trim_name', e?.trim_name)
    formData.append('vehicle_modle_id', e?.modle_id)
    axios
      .post(URL_API + `auth/admin/trim`, formData)
      .then((response) => {
        if (response?.data?.status === 200) {
          getTrimList(e?.modle_id)
          reset()
          setShowStatus('')
          // setTrims(response?.data?.trims)
          // setModalName(response?.data?.model)
          toast.success("Trim Created Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });

        }
      });
  }



  const onTrimUpdate = (e) => {
    const formData = new FormData()
    formData.append('trim_name', e?.trim_name)
    formData.append('vehicle_modle_id', e?.modle_id)
    axios
      .post(URL_API + `auth/admin/trim-update/${trimEditId}`, formData)
      .then((response) => {
        if (response?.data?.status === 200) {
          getTrimList(e?.modle_id)
          reset()
          setShow2(false)
          // setTrims(response?.data?.trims)
          // setModalName(response?.data?.model)
          toast.success("Trim Updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });

        }
      });
  }


  //loader
  const [showLoader, setShowLoader] = useState(false)
  const handleCloseLoader = () => setShowLoader(false)


  console.log('erorrrs', errors)


  const destroyModelTrim = (id) => {
    axios
      .post(URL_API + `auth/admin/trim-destroy/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          toast.success("Trim Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getTrimList(lastTrimModelId)
          // getModels();
        }
      });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  <strong>{models?.vehicle_name}</strong> Models
                </CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <Link to={`/admin/maker/model/create-model-${id.id}-${models?.vehicle_name}`}>
                  <strong>Add Model + </strong>
                </Link>
              </div>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th style={{ width: "200px" }}>Name</th>
                      <th>Image</th>
                      <th>Model Trims</th>
                      <th>Slug</th>
                      <th>Description</th>
                      <th>Created At</th>
                      <th>Action</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {models?.vehicle_modles?.map(
                      (model, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{model?.modle_name}</td>
                            <td>
                              <img
                                height="140"
                                width="140"
                                src={IMAGE_URL + model?.image}
                              />
                            </td>
                            <td>
                              <button className="form-control" onClick={() => getTrimList(model?.id)}><strong>TRIM LIST</strong> </button>

                            </td>
                            <td>{model?.slug}</td>
                            <td>{model?.description?.substring(0, 50)}...</td>

                            <td>
                              {moment(model?.created_at).format(
                                " DD MMMM,YYYY"
                              )}
                            </td>

                            <td>
                              {/* <a style={{color:"#77ac54"}} href={`article/detail/${tag.id}`}>
                                  <i class="fas fa-eye fa-lg"></i>
                                </a>
                                &nbsp;&nbsp; */}
                              <Link to={`edit/${model.id}`}>
                                <i class="far fa-edit fa-lg"></i>
                              </Link>
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <a
                                style={{ color: "red" }}
                                onClick={() => destroyModel(model.id)}
                              >
                                <i class="fas fa-trash-alt fa-lg"></i>
                              </a>
                            </td>
                          </tr>
                        );
                      }
                      // )
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        style={{ marginTop: '100px', marginLeft: '-28px' }}
      >
        <Modal.Header>
          <Modal.Title className=" ml-auto mr-auto pr-1">
            {modalName?.modle_name} Trim List<br /><button className="form-control" onClick={() => onchangeAddTrimButton('Add')}>+ Add Trim</button>
          </Modal.Title><br />
        </Modal.Header>
        {/* <form> */}

        <div className={`container-fluid`}>
          <div className={styles.HeroiImgBlogForm}></div>
          <br />
          <div className="container">
            {showStatus == 'Add'
              &&
              // ADD TRIM
              <>
                <form onSubmit={handleSubmit(onTrimsubmit)}>
                  <div className={`form ${styles.blogPostForm}`}>
                    <div className="form-group">
                      <label htmlFor="post-title" className={styles.labelPostForm}>
                        Add New Trim
                      </label>
                      <select
                        {...register('modle_id', { required: true })}
                        className="form-control"
                        name="modle_id"
                        onChange={(e) => setModelChange(e?.target?.value)}
                      >
                        <option value={''}>Select Model</option>
                        {models?.vehicle_modles?.map((type) => {
                          return <option value={type?.id}>{type?.modle_name}</option>
                        })}
                      </select>
                      <br />
                      {errors.modle_id &&
                        errors.modle_id.type === 'required' && (
                          <span>required *</span>
                        )}
                    </div>
                    <div className="form-group">
                      <input
                        className="form-control"

                        {...register('trim_name', { required: true })}
                        name="trim_name"
                        type="text"
                        id="post-title"
                        placeholder="audi"
                        onChange={(e) => setTrimName(e?.target?.value)}
                      />
                      {errors.trim_name &&
                        errors.trim_name.type === 'required' && (
                          <span>required *</span>
                        )}
                    </div>

                    <Input
                      type="submit"
                      name="submit"
                      className={`btn btn-danger ${styles.blogPostFormBtn}`}
                      value="Submit"
                    />
                  </div>
                </form>
              </>
            }




            <div className="container">
              <Table responsive>
                <thead className="text-primary">
                  <tr>
                    <th>#</th>
                    <th style={{ width: "200px" }}>Name</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {trims?.map(
                    (trim, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{trim?.trim_name}</td>
                          <td>
                            {moment(trim?.created_at).format(
                              " DD MMMM,YYYY"
                            )}
                          </td>

                          <td>

                            <a onClick={() => editModelTrim(trim.id)} ><i class="far fa-edit fa-lg"></i></a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a
                              style={{ color: "red" }}
                              onClick={() => destroyModelTrim(trim.id)}
                            >
                              <i class="fas fa-trash-alt fa-lg"></i>
                            </a>
                          </td>
                        </tr>
                      );
                    }
                    // )
                  )}
                </tbody>
              </Table>
            </div>
            <br />
            <br />
          </div>
        </div>
        {/* <BlogForm handleChange={handleChange} /> */}

      </Modal>

      <Modal
        show={show2}
        onHide={handleClose2}
        style={{ marginTop: '100px', marginLeft: '-28px' }}
      >
z        <div className={`container-fluid`}>
          <div className={styles.HeroiImgBlogForm}></div>
          <br />
          <div className="container">
            {showStatus == 'Edit'
              &&
              // EDIT TRIM
              <>
                <form onSubmit={handleSubmit(onTrimUpdate)}>
                  <div className={`form ${styles.blogPostForm}`}>
                    <div className="form-group">
                      <label htmlFor="post-title" className={styles.labelPostForm}>
                        Update Trim
                      </label>
                      <select
                        {...register('modle_id', { required: true })}
                        className="form-control"
                        name="modle_id"
                        onChange={(e) =>setTrimEditModel(e?.target?.value)}
                        value={trimEditModel}
                      >
                        <option value={''}>Select Trim</option>
                        {models?.vehicle_modles?.map((type) => {
                          return <option value={type?.id}>{type?.modle_name}</option>
                        })}
                      </select>
                      <br />
                      {errors.modle_id &&
                        errors.modle_id.type === 'required' && (
                          <span>required *</span>
                        )}
                    </div>
                    <div className="form-group">
                      <input
                        className="form-control"

                        {...register('trim_name', { required: true })}
                        name="trim_name"
                        type="text"
                        id="post-title"
                        placeholder="audi"
                        value={trimEditName}
                        onChange={(e) => setTrimEditName(e?.target?.value)}
                      />
                      {errors.trim_name &&
                        errors.trim_name.type === 'required' && (
                          <span>required *</span>
                        )}
                      {/* <input type="hidden" value={trimEditId} name="trim_id" /> */}
                    </div>

                    <Input
                      type="submit"
                      name="submit"
                      className={`btn btn-danger ${styles.blogPostFormBtn}`}
                      value="Update"
                    />
                  </div>
                </form>
              </>
            }
          </div>
        </div>
        {/* <BlogForm handleChange={handleChange} /> */}

      </Modal>
    </>
  );
}

export default ModelsList;
